<template>
	<div class="toTop" v-if="showBackToTop" @click="scrollToTop"></div>
</template>

<script>
	export default{
		data() {
			return{
				showBackToTop: false, // 控制按钮的显示
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			handleScroll() {
				// 当滚动到距离底部100px时显示按钮（可根据需求调整）
				const scrollY = window.scrollY
				const visibleHeight = document.documentElement.clientHeight
				const pageHeight = document.documentElement.scrollHeight
				this.showBackToTop = (scrollY + visibleHeight) > (pageHeight + 1000)
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.toTop {
		position: fixed;
		right: 190px;
		bottom: 143px;
		background: url('../assets/images/home/top.png') no-repeat;
		width: 53px;
		height: 53px;
		z-index: 9999;
		background-size: 100% 100%;
		cursor: pointer;
	}
</style>